import { render } from "./CRMWhatsappContactCardDialog.vue?vue&type=template&id=403e1048&scoped=true"
import script from "./CRMWhatsappContactCardDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappContactCardDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappContactCardDialog.vue?vue&type=style&index=0&id=403e1048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403e1048"]])

export default __exports__